import React, { useState } from 'react';
import styles from './StudentBalance.module.css';
import { FiEdit2 } from 'react-icons/fi';
import { useDispatch } from 'react-redux';
import { openModal } from '../../redux/slices/modalSlice';
import ResultAndCount from '../../components/ResultAndCount/ResultAndCount';
import Dropdown from '../../components/Dropdown/Dropdown';
import SearchBar from '../../components/SearchBar/SearchBar';
import PaginationTable from '../../components/PaginationTable/PaginationTable';
import DynamicTable from '../../components/DynamicTable/DynamicTable';
import LogoWithName from '../../components/LogoWithName/LogoWithName';
import IconAndName from '../../components/IconAndName/IconAndName';
import { MdOutlineTextSnippet } from 'react-icons/md';
import CopyRight from '../../components/CopyRight/CopyRight';

const data = [
  {
    _id: 's1',
    studentName: 'John Jacob',
    invoicedAmount: 2600,
    paidAmount: 3600,
    pendingAmount: 1000, // Overpaid
  },
  {
    _id: 's2',
    studentName: 'Jane Smith',
    invoicedAmount: 4200,
    paidAmount: 800,
    pendingAmount: 400,
  },
  {
    _id: 's3',
    studentName: 'Robert Lee',
    invoicedAmount: 5000,
    paidAmount: 3000,
    pendingAmount: 2000,
  },
  {
    _id: 's4',
    studentName: 'Emily Clark',
    invoicedAmount: 3100,
    paidAmount: 3100,
    pendingAmount: 0,
  },
  {
    _id: 's5',
    studentName: 'David Park',
    invoicedAmount: 4200,
    paidAmount: 2500,
    pendingAmount: 1100,
  },
];

const StudentBalance = () => {
  const dispatch = useDispatch();
  const [count, setCount] = useState(7);
  const [search, setSearch] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [selectedIds, setSelectedIds] = useState([]);

  const handlecreateform = () => {
    dispatch(openModal('accountingStudentBalanceCreateInvoice'));
  };
  const handleEditClick = () => {
    dispatch(openModal('chooseRange'));
  };
  const totalInvoiced = data.reduce(
    (sum, s) => sum + (s.invoicedAmount || 0),
    0
  );
  const totalPaid = data.reduce((sum, s) => sum + (s.paidAmount || 0), 0);
  const totalPending = data.reduce((sum, s) => sum + (s.pendingAmount || 0), 0);

  const headingsData = [
    {
      title: (
        <input
          type="checkbox"
          checked={selectedIds.length === data.length}
          onChange={(e) => {
            const checked = e.target.checked;
            if (checked) {
              const allIds = data.map((item) => item._id);
              setSelectedIds(allIds);
            } else {
              setSelectedIds([]);
            }
          }}
        />
      ),
      accessor: 'checkBox',
    },
    { title: 'Student Name', accessor: 'studentName' },
    { title: 'Invoiced Amount', accessor: 'invoicedAmount' },
    { title: 'Paid Amount', accessor: 'paidAmount' },
    { title: 'Pending Amount', accessor: 'pendingAmount' },
  ];
  const ActionsData = [
    {
      label: 'Add Credit',
      onclick: () => {
        dispatch(openModal('addCredit'));
      },
    },
    {
      label: 'Add Deposit',
      onclick: () => {
        dispatch(openModal('addDeposit'));
      },
    },
    {
      label: 'Create debit',
      onclick: () => {
        dispatch(openModal('createDebitNotes'));
      },
    },
  ];

  const getColumnData = (data) => {
    return data.map((item) => {
      const isChecked = selectedIds.includes(item._id);
      return {
        checkBox: (
          <input
            type="checkbox"
            checked={isChecked}
            onChange={(e) => {
              const checked = e.target.checked;
              if (checked) {
                setSelectedIds((prev) => [...prev, item._id]);
              } else {
                setSelectedIds((prev) => prev.filter((id) => id !== item._id));
              }
            }}
          />
        ),
        studentName: <LogoWithName name={item.studentName || '-'} />,
        invoicedAmount:
          item.invoicedAmount != null ? `INR ${item.invoicedAmount}` : '-',
        paidAmount: item.paidAmount != null ? `INR ${item.paidAmount}` : '-',
        pendingAmount:
          item.pendingAmount != null ? `INR ${item.pendingAmount}` : '-',
      };
    });
  };

  const displayData = getColumnData(data);

  return (
    <>
      <div className={styles.mainContainer}>
        <div className={styles.container}>
          <div className={styles.createForm}>
            <IconAndName
              icon={<MdOutlineTextSnippet />}
              title="Create Invoice"
              bgColor="Primary_Color"
              onClick={handlecreateform}
            />
          </div>
          {/* 🟩 Result Cards + This Month */}
          <div className={styles.rowWrapper}>
            <div className={styles.cardsWrapper}>
              <ResultAndCount
                label="Invoiced Amount"
                count={`${totalInvoiced}/-`}
                bgColor="rgba(from var(--Success_Color) r g b / 0.4)"
                textColor="Black_Color"
              />
              <ResultAndCount
                label="Paid Amount"
                count={`${totalPaid}/-`}
                bgColor="rgba(from var(--Primary_Color) r g b / 0.35)"
                textColor="Black_Color"
              />
              <ResultAndCount
                label="Pending Amount"
                count={`${totalPending}/-`}
                bgColor="rgba(from var(--Warning_Color) r g b / 0.6)"
                textColor="Black_Color"
              />
            </div>

            <div className={styles.editWrapper} onClick={handleEditClick}>
              <FiEdit2 size={16} />
              <span>This Month</span>
            </div>
          </div>

          {/* 🔍 Search & Filters Row */}
          <div className={styles.totalstudentcard}>
            <div className={styles.studentsection}>
              <div className={styles.search}>
                <SearchBar
                  placeholder="Search Student"
                  onChange={(e) => console.log(e.target.value)}
                />
              </div>
              <div className={styles.filters}>
                <Dropdown
                  label="Room"
                  options={['Room1', 'Room2']}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Group"
                  options={['Group 1', 'Group 2']}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Program"
                  options={['Annual Day', 'Freshers']}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
                <Dropdown
                  label="Actions"
                  options={ActionsData.map((item, index) => {
                    return (
                      <div
                        key={index}
                        className={styles.dropdownItem}
                        onClick={item.onclick}
                      >
                        {item.label}
                      </div>
                    );
                  })}
                  bgColor="rgba(from var(--Utility_Color1) r g b / 1)"
                />
              </div>
            </div>

            {/* Student Data Table */}
            <div className={styles.dynamicdata}>
              <DynamicTable
                headings={headingsData}
                columnData={displayData.slice(
                  (currentPage - 1) * itemsPerPage,
                  currentPage * itemsPerPage
                )}
              />
            </div>
            <div className={styles.paginationTable}>
              <PaginationTable
                data={displayData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                setCurrentPage={setCurrentPage}
                setItemsPerPage={setItemsPerPage}
              />
            </div>
          </div>
        </div>
      </div>
      <CopyRight />
    </>
  );
};

export default StudentBalance;
